// Gets the associated wishlist state for [session]
export const WishlistService_GetWishlistStateLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_GetWishlistState);
WishlistService_GetWishlistStateLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/GetWishlistState" as const;

// Adds a product to wishlist
export const WishlistService_AddProductLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_AddProduct);
WishlistService_AddProductLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/AddProduct" as const;

// Removes a product from wishlist
export const WishlistService_RemoveProductLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_RemoveProduct);
WishlistService_RemoveProductLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/RemoveProduct" as const;
